import angular from 'angular';
import { boHeader } from './app/header.component.js';

(function() {
    'use strict';

    angular.module('app.layouts', []).component('boHeader', boHeader);
})();
